import React from "react";
import { NavHashLink } from "react-router-hash-link";
import useAuth from "../../../Hooks/useAuth";

const MenuSIdeBar = ({ setSideMenu, isHome }) => {
  const { user, isAdmin } = useAuth();

  return (
    <div>
      <div>
        <svg
          onClick={() => setSideMenu(false)}
          xmlns="http://www.w3.org/2000/svg"
          className="h-7 w-7 ml-auto cursor-pointer"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </div>
      <div className="mt-4 space-y-4">
        <NavHashLink
          className={(isActive) =>
            `bg-gray-900 text-white p-3 block hover:bg-gray-800 transition-all rounded-sm`
          }
          to="/"
        >
          Home
        </NavHashLink>
        <NavHashLink
          className={(isActive) =>
            `bg-gray-900 text-white p-3 block hover:bg-gray-800 transition-all rounded-sm`
          }
          to="/blogs"
        >
          Blogs
        </NavHashLink>

        <NavHashLink
          className={(isActive) =>
            `bg-gray-900 text-white p-3 block hover:bg-gray-800 transition-all rounded-sm`
          }
          to="/#about"
        >
          About Me
        </NavHashLink>

        <NavHashLink
          className={(isActive) =>
            `bg-gray-900 text-white p-3 block hover:bg-gray-800 transition-all rounded-sm`
          }
          to="/#projects"
        >
          Projects
        </NavHashLink>
        <NavHashLink
          className={(isActive) =>
            `bg-gray-900 text-white p-3 block hover:bg-gray-800 transition-all rounded-sm`
          }
          to="/#contact"
        >
          Contact
        </NavHashLink>

        {isAdmin && user.email && (
          <NavHashLink
            className={(isActive) =>
              `bg-gray-900 text-white p-3 block hover:bg-gray-800 transition-all rounded-sm`
            }
            to="/admin-dashboard"
          >
            Dashboard
          </NavHashLink>
        )}
      </div>
    </div>
  );
};

export default MenuSIdeBar;
